import React from 'react';
import Dashboard from '../Dashboard.jsx';

const Home = () => {
    return (
        <><Dashboard></Dashboard></>
    );
}

export default Home;
